module.exports = __webpack_public_path__ + "img/CompScope_Bright_02.016bb6d3.png";